module.exports = __webpack_public_path__ + "static/media/close.e5ef77f2.svg";